import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext({
    lang: "en",
    setLang: () => {},
    t: (key) => key,
});

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        if (typeof window === "undefined") return "en";
        return localStorage.getItem("sg_lang") || "en";
    });

    useEffect(() => {
        localStorage.setItem("sg_lang", lang);
        if (typeof document !== "undefined") {
            document.documentElement.setAttribute("lang", lang);
        }
    }, [lang]);

    const value = useMemo(() => {
        const dict = translations[lang] || translations.en;
        const t = (key) => {
            const parts = key.split(".");
            let cur = dict;
            for (const p of parts) {
                if (cur && typeof cur === "object" && p in cur) cur = cur[p];
                else return key;
            }
            return cur;
        };
        return { lang, setLang, t };
    }, [lang]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
